import { useState, useEffect } from 'react';
import { useContentEnginePrinters } from '@pm2/content-engine';
import { pm2SitemapStore, findPageDescriptorByPath } from '@pm2/sitemap-utils';
import { useLocation } from '@provider/navigation';
import { printManager } from '@provider/print';
import { FloatingActionButton, PrinterIcon } from '@ui/kit';
import { printAST } from '@utils/ast';
import { useActivityIndicator, CSSRefTransition } from '@utils/react';
import { button, throbber, FADE_DURATION_MS } from './_print.style.js';
import { mergeContentEnginePrintChunks } from './util.merge-content-engine-chunks.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function PrintButton(props) {
  const {
    paperPrinters
  } = useContentEnginePrinters();
  const location = useLocation();
  const sitemap = pm2SitemapStore.useSelector(state => state);
  const [isPreparingPrint, setPreparingPrint] = useState(false);
  const activityIndicator = useActivityIndicator(isPreparingPrint);
  const descriptor = findPageDescriptorByPath(sitemap, location.pathname);
  const disabled = !props.currentAST?.length;
  useEffect(() => {
    const currentAST = props.currentAST;
    if (!currentAST || !descriptor) {
      printManager.reset();
      return;
    }
    printManager.registerBeforePrintHandler(async () => {
      const printed = printAST(currentAST, paperPrinters);

      // NB: Force rerendering upon printing in case content has been
      // changed since last print, which is possible during input
      await printManager.preparePrint(String(Math.random()), "browser", {
        debug: true,
        format: "A4-portrait",
        sections: mergeContentEnginePrintChunks(printed)
      });
    });
  }, [props.currentAST, descriptor, paperPrinters]);
  const handlePrint = async () => {
    if (!props.currentAST || !descriptor) {
      return;
    }
    try {
      setPreparingPrint(true);
      const printed = printAST(props.currentAST, paperPrinters);
      await printManager.preparePrint(`${Math.random()}`, "browser", {
        debug: false,
        format: "A4-portrait",
        sections: mergeContentEnginePrintChunks(printed)
      });
      printManager.triggerPrintDialog();
    } finally {
      setPreparingPrint(false);
    }
  };
  return /*#__PURE__*/jsx("div", {
    className: button,
    children: /*#__PURE__*/jsx(FloatingActionButton, {
      tooltip: {
        ariaType: "label",
        placement: "left",
        body: disabled ? "Siden kan ikke printes" : "Print siden (Ctrl + P)"
      },
      onClick: handlePrint,
      disabled: disabled,
      children: /*#__PURE__*/jsxs(FloatingActionButton.Icon, {
        children: [/*#__PURE__*/jsx(PrinterIcon, {}), /*#__PURE__*/jsx(CSSRefTransition, {
          in: activityIndicator.isActive(),
          timeout: FADE_DURATION_MS,
          classNames: throbber,
          mountOnEnter: true,
          unmountOnExit: true,
          children: ref => /*#__PURE__*/jsx("span", {
            ref: ref,
            className: throbber
          })
        })]
      })
    })
  });
}

export { PrintButton };
//# sourceMappingURL=_print.js.map
